var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('div',[(_vm.pending)?_c('div',[_vm._v("...Подождите немного")]):_vm._e(),(_vm.error)?_c('div',[_c('div',{staticClass:"error--text mb-2"},[_vm._v(_vm._s(_vm.error))]),_c('v-btn',{attrs:{"color":"primary","outlined":"","to":"/"}},[_vm._v("На главную")])],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }